import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const LockFilledIcon = ({
  width = '12px',
  height = '14px',
  color = '#CCCCCC'
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    style={{
      fill: color,
      width: width,
      height: height
    }}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 12 14"
    version="1.1"
  >
    <g id="surface1">
      <path d="M11.333 7.00016C11.333 6.26483 10.735 5.66683 9.99972 5.66683H9.33305V3.66683C9.33305 1.82883 7.83772 0.333496 5.99972 0.333496C4.16172 0.333496 2.66638 1.82883 2.66638 3.66683V5.66683H1.99972C1.26438 5.66683 0.666382 6.26483 0.666382 7.00016V12.3335C0.666382 13.0688 1.26438 13.6668 1.99972 13.6668H9.99972C10.735 13.6668 11.333 13.0688 11.333 12.3335V7.00016ZM3.99972 3.66683C3.99972 2.56416 4.89705 1.66683 5.99972 1.66683C7.10238 1.66683 7.99972 2.56416 7.99972 3.66683V5.66683H3.99972V3.66683Z" />
    </g>
  </IconSvg>
)

export default LockFilledIcon
